import { render, staticRenderFns } from "./AgendaPelatihan.vue?vue&type=template&id=64de5869&scoped=true"
import script from "./AgendaPelatihan.vue?vue&type=script&lang=js"
export * from "./AgendaPelatihan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de5869",
  null
  
)

export default component.exports